import script from "./IntegrationConfigsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegrationConfigsView.vue?vue&type=script&setup=true&lang=ts"

import "./IntegrationConfigsView.vue?vue&type=style&index=0&id=28516291&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28516291"]])

export default __exports__